<span
    [fiVariation]="variation"
    [fiVariationBase]="'fi-alert-icon'"
    class="fi-alert-icon"
>
    <span class="fi-text fi-text--white">!</span>
</span>
